/**
 * Project panel
 * Skeleton.js
 * Created by stefensuhat on 2018-11-30 14:28
 */

import { AppBar, makeStyles, Toolbar } from '@material-ui/core';
import React from 'react';
import Base from './Base';
import Progress from './Progress';

const propTypes = {};
const defaultProps = {};
const styles = makeStyles(theme => ({
    paper: {
        // maxWidth: 936,
        margin: 'auto',
        overflow: 'hidden',

        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
        },
    },
    searchBar: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    contentWrapper: {
        // overflowY: 'scroll',
        overflowX: 'auto',
        // margin: `${unit * 5}px ${unit * 2}px`,
    },
    loadingWrapper: {
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
        // margin: `${unit * 5}px ${unit * 2}px`,
    },
}));

function Skeleton({ renderToolbar, loading, children: Component }) {
    const classes = styles();

    return (
        <Base elevation={4}>
            {renderToolbar && (
                <AppBar className={classes.searchBar} position="static" color="default" elevation={0}>
                    <Toolbar>
                        {renderToolbar}
                    </Toolbar>
                </AppBar>
            )}
            <div className={classes.contentWrapper}>
                {loading ? <Progress /> : Component}
            </div>
        </Base>
    );
}

Skeleton.propTypes = propTypes;
Skeleton.defaultProps = defaultProps;

export default Skeleton;
